import React from 'react'

import DateTime from '../../../../components/job/datetime'
import { Badge, Descriptions } from 'antd'
import PropTypes from 'prop-types'

const propTypes = {
  job: PropTypes.object.isRequired
}

const defaultProps = {}

const DeliveryStatus = ({ job }) => {
  if (job.delivery_on_time) {
    return <Badge status='success' text='On Time' />
  }

  return <Badge status='error' text='Out of Time' />
}

const ServiceTab = ({ job }) => {
  const isAssigned = job.started_at ? true : false
  const isDelivery = job.status === 'Completed' || job.status === 'Delivered'

  return (
    <Descriptions size='middle' itle='User Info' layout='vertical' bordered column={5}>
      <Descriptions.Item label='Received At'>
        {job.received_at && <DateTime value={job.received_at} />}
      </Descriptions.Item>
      <Descriptions.Item label='Created At'>
        <DateTime value={job.created_date} />
      </Descriptions.Item>
      <Descriptions.Item label='Assignment At'>
        {isAssigned && <DateTime value={job.started_at} />}
      </Descriptions.Item>
      <Descriptions.Item label='DDL At'>
        {job.client_deadline_at && <DateTime value={job.client_deadline_at} />}
      </Descriptions.Item>
      <Descriptions.Item label='Delivery At'>
        {isDelivery && <DateTime value={job.completed_at} />}
      </Descriptions.Item>

      <Descriptions.Item label='Time' />
      <Descriptions.Item label={`${job?.elapsed_time_on_reception} min`} />
      <Descriptions.Item label={isAssigned ? `${job?.elapsed_time_on_assignment} min` : ''} />
      {isDelivery && <Descriptions.Item label={<DeliveryStatus job={job} />} />}
      {isDelivery && (
        <Descriptions.Item
          label={
              job.delivery_on_time
                ? `${job.elapsed_delay_time_in_delivery} min before DDL`
                : `${job.elapsed_delay_time_in_delivery} min of delay`
          }
        />
      )}
    </Descriptions>
  )
}

ServiceTab.propTypes = propTypes
ServiceTab.defaultProps = defaultProps

export default ServiceTab
